export default __webpack_public_path__ + "static/media/p6.5e30e710.jpg";